<template>
  <div class="ocean">
    <div class="header">
      <AppHeader></AppHeader>
    </div>
    <Banner></Banner>
  </div>
</template>
<script>
import AppHeader from './components/AppHeader.vue'
import Banner from './components/Banner.vue'
export default {
  name: 'Ocean',
  components: {
    AppHeader,
    Banner
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/style/variables.scss';

.ocean{
  .header{
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    z-index: 9;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/ocean/index.vue